import axios from "./config";

export default {
  getPage: async function () {
    try {
      const response = axios.get("/pages");
      return response;
    } catch (error) {
      console.log(error);
    }
  },

  makeListServiceQueryParams: function ({
    cloud_provider_id = "",
    search = "",
    role = "",
    project_id = "",
    is_active = "",
    customer_id = "",
    team_id = "",
    board_id = "",
    company_id = "",
    username = "",
  }) {
    
    const params = new URLSearchParams();
    if (search) {
      params.append("search", search);
    }
    if (role) {
      params.append("role", role);
    }
    if (project_id) {
      params.append("project_id", project_id);
    }
    if (customer_id) {
      params.append("customer_id", customer_id);
    }
    if (is_active) {
      const value = is_active === "1" ? true : false;
      params.append("is_active", value);
    }
    if (team_id) {
      params.append("team_id", team_id);
    }
    if (board_id) {
      params.append("board_id", board_id);
    }
    if (company_id) {
      params.append("company_id", company_id);
    }
    if (username) {
      params.append("username", username);
    }
    if (cloud_provider_id) params.append("cloud_provider_id", cloud_provider_id);
    return params;
  },


  makeListServiceQueryParamsDynamic: function (queryParams = {}) {
    const params = new URLSearchParams();
  
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        if (typeof value === "boolean") {
          params.append(key, value ? "true" : "false");
        } else {
          params.append(key, value);
        }
      }
    });
  
    return params;
  },
};
